import { ProductTypes } from "./ProductTypes";

export const Accessories = [
  ProductTypes.BLUETOOTH_HEADPHONE,
  ProductTypes.PREPAID_INTERNET,
  ProductTypes.JEWLERY,
  ProductTypes.PURSE,
  ProductTypes.CHARGER,
  ProductTypes.MEMORY,
  ProductTypes.HEADPHONE,
  ProductTypes.ACCESSORY,
  ProductTypes.WATCH,
  ProductTypes.SMART_BAND
];

export default Accessories;
